module.exports = __webpack_public_path__ + "media/images/country_flags/pr-bc1d0806c9770120e7c79154577172fd.png";